import { POST } from '@/lib/api/Methods';
import {
   LoginPayload,
   TLogin,
   TRequestSignup,
   TResendOtp,
   TVerifyEmailLink,
   TVerifyEmailOTP,
   TResetPassword,
   TVerifyEmail,
   TCLinicRequestSignup,
   TPartnerPackagePaymentRequest,
} from './auth.types';
import { TPersonalDetails } from '@/components/features/registration/forms/personal-details/personal-details.validator';
import { User } from '@/core/models';
import { TClinicsPackageSelection } from '@/components/features/registration/forms/package-list/clinicsPackageSelection.schema';

export const requestSignup = async (data: TRequestSignup) =>
   POST<TRequestSignup, unknown>('/auth/request-signup', data);

export const resendOtp = async (email: string) => POST<TResendOtp, unknown>('/auth/resend-otp', { email });

export const verifyEmailWithOtp = async (data: TVerifyEmailOTP) =>
   POST<TVerifyEmailOTP, TLogin>('/auth/verify-email-with-otp', data);

export const verifyWithLink = async (token: string) =>
   POST<TVerifyEmailLink, TLogin>('/auth/verify-email-with-link', { token });

export const createPersonalDetails = async (data: TPersonalDetails) =>
   POST<TPersonalDetails, User>('/auth/create-user-details', data);

export const userLogin = async (data: LoginPayload) => POST<LoginPayload, TLogin>('/auth/user-login', data);

export const forgotPassword = async (email: string) =>
   POST<{ email: string }, unknown>('/auth/forgot-password', { email });

export const resetPassword = async (data: TResetPassword) =>
   POST<TResetPassword, unknown>('/auth/recover-password', data);

export const verifyIdentity = async (data: TVerifyEmail) => POST<TVerifyEmail, unknown>('/auth/verify-identity', data);

export const requestClinicSignup = async (data: TCLinicRequestSignup) =>
   POST<TCLinicRequestSignup, unknown>('/auth/clinic/request-signup', data);

export const requestPartnerSignup = async (data: TRequestSignup) =>
   POST<TRequestSignup, unknown>('/auth/partner/request-signup', data);

export const partnerPackagePaymentRequest = (payload: TPartnerPackagePaymentRequest) =>
   POST<unknown, unknown>('/user/create-package-request-partner', payload);

export const clinicPackageCreateRequest = (payload: TClinicsPackageSelection[]) =>
   POST<unknown, unknown>('/auth/create-clinic-packages', payload);

export const clinicPackageCreateAdd = (payload: TClinicsPackageSelection) =>
   POST<unknown, unknown>('/auth/add-clinic-packages', payload);
